const contractColumns = [
    { field: 'id', text: 'Код договора', width: 100, visible: false },
    { field: 'no', text: 'Номер договора', width: 100, visible: true },
    { field: 'active_id', text: 'Код статуса договора', width: 100, visible: false },
    { field: 'vid_id', text: 'Код вида договора', width: 100, visible: false },
    { field: 'dt_ini', text: 'Дата начала действия договора', width: 100, visible: true },
    { field: 'dt_fin', text: 'Дата окончания действия договора', width: 100, visible: true },
    { field: 'abon', text: 'Код абонента', width: 100, visible: false },
    { field: 'abon_name', text: 'Наименование абонента', width: 100, visible: true },
    { field: 'abon_active_id', text: 'Код статуса абонента', width: 100, visible: false },
    { field: 'inn', text: 'ИНН абонента', width: 100, visible: true },
    { field: 'dep_id', text: 'Код отделения', width: 100, visible: false },
    { field: 'dep_name', text: 'Наименование отделения', width: 100, visible: true },
];

const objectColumns = [
    { dataField: 'id', caption: 'Код объекта', visible: false },
    { dataField: 'n', caption: 'Наименование объекта', visible: true },
    { dataField: 'a', caption: 'Адрес объекта', visible: true },
];

const meteringPointColumns = [
    { dataField: 'contract_id', caption: 'Код договора', visible: false },
    { dataField: 'contract_obj_id', caption: 'Код объекта', visible: false },
    { dataField: 'tu_id', caption: 'Код точки учёта', visible: false },
    { dataField: 'obj_num', caption: 'Номер объекта', visible: true },
    { dataField: 'obj_name', caption: 'Наименование объекта', visible: true },
    { dataField: 'obj_adr', caption: 'Адрес объекта', visible: true },
    { dataField: 'tu_num', caption: 'Номер точки учёта', visible: true },
    { dataField: 'tu_name', caption: 'Наименование точки учёта', visible: true },
    { dataField: 'tu_dat_i', caption: 'Дата создания точки учёта', visible: true },
    { dataField: 'tu_dat_f', caption: 'Дата удаления точки учёта', visible: true },
    { dataField: 'pu_num', caption: 'Номер прибора учёта', visible: true },
    { dataField: 'pu_type', caption: 'Тип прибора учёта', visible: true },
    { dataField: 'pu_dat_i', caption: 'Дата установки прибора учёта', visible: true },
    { dataField: 'pu_dat_f', caption: 'Дата снятия прибора учёта', visible: true },
    { dataField: 'tu_note', caption: 'Примечание', visible: true },
];

const annexColumns = [
    { dataField: 'id', caption: 'Код приложения', visible: false },
    { dataField: 'nm', caption: 'Приложение', visible: true },
];

const typeContractColumns = [
    { dataField: 'id', caption: 'Код вида договора', visible: false },
    { dataField: 'nm', caption: 'Вид договора', visible: true },
];

export default {
    groups: [
        {
            id: 1,
            label: 'Для каких договоров печатаем',
            collapsed: true,
            entitySelection: {
                exist: true,
                type: 'contract',
                fieldNameId: 'contract_entity_selection_text',
                fieldNameText: 'contract_entity_selection_id',
            },
        },
        {
            id: 2,
            label: 'Для каких объектов печатаем',
            collapsed: true,
            entitySelection: {
                exist: true,
                type: 'object',
                fieldNameId: 'object_entity_selection_text',
                fieldNameText: 'object_entity_selection_id',
            },
        },
        {
            id: 3,
            label: 'Точки учёта',
            collapsed: true,
            entitySelection: {
                exist: true,
                type: 'meteringPoint',
                fieldNameId: 'metering_point_entity_selection_text',
                fieldNameText: 'metering_point_entity_selection_id',
            },
        },
        {
            id: 4,
            label: 'Что печатать',
            collapsed: true,
            entitySelection: {
                exist: false,
                type: '',
                fieldNameId: '',
                fieldNameText: '',
            },
        },
        {
            id: 5,
            label: 'Кто подписывает',
            collapsed: true,
            entitySelection: {
                exist: true,
                type: 'contractSigned',
                fieldNameId: 'contract_signed_entity_selection_text',
                fieldNameText: 'contract_signed_entity_selection_id',
            },
        },
        {
            id: 6,
            label: 'Куда печатать',
            collapsed: true,
            entitySelection: {
                exist: false,
                type: '',
                fieldNameId: '',
                fieldNameText: '',
            },
        },
    ],
    components: [
        /*
            group 1 Для каких договоров печатаем
         */

        {
            name: 'pca-form-date-box',
            title: 'По состоянию на',
            fieldNameText: 'as_of_date',
            groupId: 1,
            size: [1, 2],
            extParams: {
                entitySelectionId: null,
            },
        },
        {
            name: 'pca-form-text-box-virtual-grid-dictionary',
            title: 'Список договоров',
            groupId: 1,
            size: [1, 2],
            fieldNameId: 'list_contract_value',
            fieldNameText: 'list_contract_number',
            maxViewingElements: 10,
            validationRules: {
                required: false,
            },
            extParams: {
                displayExpr: 'no',
                valueExpr: 'id',
                loadUrl: 'meta./report/contract-list/data/get',
                keyExpr: 'id',
                autoLoadData: false,
                toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
                selectionMode: 'multiple',
                meta_args: {
                    key: 'id',
                    db_schema_name: 'dog_prn',
                    db_view_name: 'kv_contract',
                },
                columns: contractColumns,
                entitySelectionId: 1,
            },
        },

        {
            name: 'pca-form-select-box',
            title: 'Статус договора',
            groupId: 1,
            size: [1, 2],
            fieldNameId: 'contract_status_text',
            fieldNameText: 'contract_status_value',
            showClearButton: true,
            extParams: {
                displayExpr: 'nm',
                valueExpr: 'id',
                dictionaryRoutePath: 'counteragent./report/activity-status-dict/get',
                entitySelectionId: 2,
            },
        },
        {
            name: 'pca-grid-dictionary',
            groupId: 1,
            title: 'Вид договора',
            size: [1, 2],
            fieldNameId: 'list_type_contract_value',
            fieldNameText: 'list_type_contract_name',
            dataType: 'type_contract',
            extParams: {
                displayExpr: 'nm',
                valueExpr: 'id',
                entitySelectionId: 2,
                gridRoMeta: {
                    allowSelectAll: false,
                    keyExpr: 'id',
                    selectionMode: 'multiple',
                    columns: typeContractColumns,
                    api: { select: 'counteragent./report/contract-template-list/get' },
                },
            },
        },
        {
            name: 'pca-grid-dictionary',
            groupId: 1,
            title: 'Подразделение',
            size: [1, 2],
            fieldNameId: 'subdivision_id',
            fieldNameText: 'subdivision_name',
            dataType: 'subdivision',
            extParams: {
                displayExpr: 'nm',
                valueExpr: 'id',
                entitySelectionId: 2,
                gridRoMeta: {
                    allowSelectAll: false,
                    keyExpr: 'id',
                    selectionMode: 'multiple',
                    columns: typeContractColumns,
                    api: { select: 'counteragent./report/contract-template-list/get' },
                },
            },
        },
        {
            name: 'pca-grid-dictionary',
            groupId: 1,
            title: 'Ответственный за договор',
            size: [1, 2],
            fieldNameId: 'responsible_for_contract_id',
            fieldNameText: 'responsible_for_contract_name',
            dataType: 'responsible_for_contract',
            extParams: {
                displayExpr: 'nm',
                valueExpr: 'id',
                entitySelectionId: 2,
                gridRoMeta: {
                    allowSelectAll: false,
                    keyExpr: 'id',
                    selectionMode: 'single',
                    columns: typeContractColumns,
                    api: { select: 'counteragent./report/contract-template-list/get' },
                },
            },
        },

        /*
            group 2 Для каких объектов печатаем
         */

        {
            name: 'pca-grid-dictionary',
            groupId: 2,
            title: 'Список объектов',
            size: [1, 2],
            fieldNameId: 'list_object_value',
            fieldNameText: 'list_object_number',
            dataType: 'objects',
            extParams: {
                displayExpr: 'n',
                valueExpr: 'id',
                entitySelectionId: 1,
                gridRoMeta: {
                    allowSelectAll: true,
                    keyExpr: 'id',
                    selectionMode: 'multiple',
                    columns: objectColumns,
                    api: { select: 'counteragent./report/contract/object-list/get' },
                },
            },
        },
        {
            name: 'pca-form-select-box',
            title: 'Статус объектов',
            groupId: 2,
            size: [1, 2],
            fieldNameId: 'object_status_text',
            fieldNameText: 'object_status_value',
            showClearButton: true,
            extParams: {
                displayExpr: 'nm',
                valueExpr: 'id',
                dictionaryRoutePath: 'counteragent./report/activity-status-dict/get',
                entitySelectionId: 2,
            },
        },

        /*
            group 3 Точки учёта
         */

        {
            name: 'pca-form-select-box',
            title: 'Статус точек учёта',
            groupId: 3,
            size: [1, 2],
            fieldNameId: 'metering_point_status_text',
            fieldNameText: 'metering_point_status_value',
            showClearButton: true,
            extParams: {
                displayExpr: 'nm',
                valueExpr: 'id',
                dictionaryRoutePath: 'counteragent./report/activity-status-dict/get',
                entitySelectionId: 2,
            },
        },
        {
            name: 'pca-form-date-box',
            title: 'Период создания точки учёта (ТУ). С',
            fieldNameText: 'metering_point_creation_date',
            groupId: 3,
            size: [1, 2],
            extParams: {
                entitySelectionId: 2,
            },
        },
        {
            name: 'pca-form-date-box',
            title: 'Период создания точки учёта (ТУ). По',
            fieldNameText: 'metering_point_deletion_date',
            groupId: 3,
            size: [1, 2],
            extParams: {
                entitySelectionId: 2,
            },
        },
        {
            name: 'pca-form-date-box',
            title: 'Период замены прибора учёта (ПУ). С',
            fieldNameText: 'electricity_meter_installation_date',
            groupId: 3,
            size: [1, 2],
            extParams: {
                entitySelectionId: 2,
            },
        },
        {
            name: 'pca-form-date-box',
            title: 'Период замены прибора учёта (ПУ). По',
            fieldNameText: 'electricity_meter_removal_date',
            groupId: 3,
            size: [1, 2],
            extParams: {
                entitySelectionId: 2,
            },
        },
        {
            name: 'pca-form-check-box',
            title: 'Печатать с постоянным расходом',
            fieldNameText: 'print_with_constant_consumption',
            groupId: 3,
            size: [1, 2],
            extParams: {
                entitySelectionId: 2,
            },
        },
        {
            name: 'pca-grid-dictionary',
            groupId: 3,
            title: 'Список точек учёта',
            size: [1, 2],
            fieldNameId: 'list_metering_point_value',
            fieldNameText: 'list_metering_point_number',
            dataType: 'metering_points',
            extParams: {
                displayExpr: 'tu_name',
                valueExpr: 'tu_id',
                entitySelectionId: 2,
                gridRoMeta: {
                    allowSelectAll: true,
                    keyExpr: 'tu_id',
                    selectionMode: 'multiple',
                    columns: meteringPointColumns,
                    api: { select: 'counteragent./report/meter-point-list/get' },
                },
            },
        },

        /*
            group 4 Что печатать
         */

        {
            name: 'pca-form-check-box',
            title: 'Договор',
            fieldNameText: 'must_be_printed_contract',
            groupId: 4,
            size: [1, 1],
            extParams: {
                entitySelectionId: null,
            },
        },
        {
            name: 'pca-form-check-box',
            title: 'Приложения',
            fieldNameText: 'must_be_printed_annexes',
            groupId: 4,
            size: [1, 1],
            extParams: {
                entitySelectionId: null,
            },
        },
        {
            name: 'pca-form-check-box',
            title: 'Типовые письма',
            fieldNameText: 'must_be_printed_standard_letters',
            groupId: 4,
            size: [1, 1],
            extParams: {
                entitySelectionId: null,
            },
        },
        {
            name: 'pca-form-check-box',
            title: 'Претензии',
            fieldNameText: 'must_be_printed_claims',
            groupId: 4,
            size: [1, 3],
            extParams: {
                entitySelectionId: null,
            },
        },
        {
            name: 'pca-select-box-local-data',
            title: 'Форма приложений(ия) к договору',
            groupId: 4,
            size: [1, 1],
            fieldNameId: 'annex_form_entity_selection_text',
            fieldNameText: 'annex_form_entity_selection_id',
            extParams: {
                valueExpr: 'id',
                displayExpr: 'text',
                entitySelection: 'annexForm',
                entitySelectionId: null,
            },
        },
        {
            name: 'pca-grid-dictionary',
            groupId: 4,
            title: 'Список приложений',
            size: [1, 2],
            fieldNameId: 'list_annex_value',
            fieldNameText: 'list_annex_name',
            dataType: 'annexes',
            extParams: {
                displayExpr: 'nm',
                valueExpr: 'id',
                entitySelectionId: null,
                gridRoMeta: {
                    allowSelectAll: true,
                    keyExpr: 'id',
                    selectionMode: 'multiple',
                    columns: annexColumns,
                    api: { select: 'counteragent./report/annex-template-list/get' },
                },
            },
        },
        {
            name: 'pca-form-check-box',
            title: 'Одним файлом',
            fieldNameText: 'print_in_one_file',
            groupId: 4,
            size: [1, 1],
            extParams: {
                entitySelectionId: null,
            },
        },
        {
            name: 'pca-form-check-box',
            title: 'Заменить',
            fieldNameText: 'replace_existing_file',
            groupId: 4,
            size: [1, 1],
            extParams: {
                entitySelectionId: null,
            },
        },
        {
            name: 'pca-form-check-box',
            title: 'Сформировать pdf',
            fieldNameText: 'generate_in_pdf',
            groupId: 4,
            size: [1, 1],
            extParams: {
                entitySelectionId: null,
            },
        },

        /*
            group 5 Кто подписывает
         */

        {
            name: 'pca-grid-dictionary',
            groupId: 5,
            title: 'Сотрудник',
            size: [1, 4],
            fieldNameId: 'contract_signed_value',
            fieldNameText: 'contract_signed_number',
            dataType: 'contract_signed',
            extParams: {
                displayExpr: 'nm',
                valueExpr: 'id',
                entitySelectionId: 1,
                gridRoMeta: {
                    allowSelectAll: true,
                    keyExpr: 'id',
                    selectionMode: 'single',
                    columns: annexColumns,
                    api: { select: 'counteragent./report/annex-template-list/get' },
                },
            },
        },
        {
            name: 'pca-grid-dictionary',
            groupId: 5,
            title: 'Должностная функция',
            size: [1, 4],
            fieldNameId: 'job_function_value',
            fieldNameText: 'job_function_number',
            dataType: 'job_function',
            extParams: {
                displayExpr: 'nm',
                valueExpr: 'id',
                entitySelectionId: 2,
                gridRoMeta: {
                    allowSelectAll: true,
                    keyExpr: 'id',
                    selectionMode: 'multiple',
                    columns: annexColumns,
                    api: { select: 'counteragent./report/annex-template-list/get' },
                },
            },
        },

        /*
            group 6 Куда печатать
         */

        {
            name: 'pca-select-box-local-data',
            title: 'Место назначения печати',
            groupId: 6,
            size: [1, 2],
            fieldNameId: 'print_where_entity_selection_text',
            fieldNameText: 'print_where_entity_selection_id',
            extParams: {
                valueExpr: 'id',
                displayExpr: 'text',
                entitySelection: 'printWhere',
                entitySelectionId: null,
            },
        },
    ],
};
